// All providers data for category and listing pages
export const allProviders = [
  {
    id: 1,
    name: 'Priya Sharma',
    avatar: 'PS',
    title: 'Compassionate in-home nursing for post-surgery recovery',
    category: 'healthcare',
    specialization: 'Post-Surgery Care',
    experience: '8 years',
    rating: 5,
    reviews: 312,
    price: 28,
    priceUnit: '/hr',
    location: 'Mumbai',
    verified: true,
    topRated: true,
    available: 'Today',
  },
  {
    id: 2,
    name: 'Anna van Dijk',
    avatar: 'AD',
    title: "Specialized dementia and Alzheimer's daily care support",
    category: 'healthcare',
    specialization: 'Elderly Care',
    experience: '12 years',
    rating: 5,
    reviews: 204,
    price: 35,
    priceUnit: '/hr',
    location: 'Amsterdam',
    verified: true,
    topRated: true,
    available: 'This week',
  },
  {
    id: 3,
    name: 'Rajesh Kumar',
    avatar: 'RK',
    title: 'Expert physiotherapy and rehabilitation services at home',
    category: 'healthcare',
    specialization: 'Physiotherapy',
    experience: '6 years',
    rating: 4,
    reviews: 156,
    price: 30,
    priceUnit: '/hr',
    location: 'Delhi',
    verified: true,
    topRated: false,
    available: 'Today',
  },
  {
    id: 4,
    name: 'Maria de Jong',
    avatar: 'MJ',
    title: 'Palliative care specialist with compassionate approach',
    category: 'healthcare',
    specialization: 'Palliative Care',
    experience: '15 years',
    rating: 5,
    reviews: 89,
    price: 40,
    priceUnit: '/hr',
    location: 'Rotterdam',
    verified: true,
    topRated: true,
    available: 'Weekends',
  },
  {
    id: 5,
    name: 'Sophie Bakker',
    avatar: 'SB',
    title: 'Full-home cleaning, organizing, and grocery assistance',
    category: 'home-support',
    specialization: 'House Cleaning',
    experience: '5 years',
    rating: 4,
    reviews: 88,
    price: 22,
    priceUnit: '/hr',
    location: 'Utrecht',
    verified: true,
    topRated: false,
    available: 'Today',
  },
  {
    id: 6,
    name: 'Geeta Devi',
    avatar: 'GD',
    title: 'Professional cook specializing in healthy home meals',
    category: 'home-support',
    specialization: 'Cooking',
    experience: '10 years',
    rating: 5,
    reviews: 234,
    price: 25,
    priceUnit: '/hr',
    location: 'Bangalore',
    verified: true,
    topRated: true,
    available: 'This week',
  },
  {
    id: 7,
    name: 'Lisa Jansen',
    avatar: 'LJ',
    title: 'Experienced nanny and childcare specialist',
    category: 'home-support',
    specialization: 'Childcare',
    experience: '8 years',
    rating: 5,
    reviews: 178,
    price: 28,
    priceUnit: '/hr',
    location: 'The Hague',
    verified: true,
    topRated: true,
    available: 'Today',
  },
  {
    id: 8,
    name: 'Arjun Patel',
    avatar: 'AP',
    title: 'Anxiety, grief, and life-transition counseling sessions',
    category: 'personal-support',
    specialization: 'Counseling',
    experience: '7 years',
    rating: 5,
    reviews: 176,
    price: 55,
    priceUnit: '/session',
    location: 'Mumbai',
    verified: true,
    topRated: true,
    available: 'Today',
  },
  {
    id: 9,
    name: 'Dr. Eva Visser',
    avatar: 'EV',
    title: 'Licensed therapist for family and relationship counseling',
    category: 'personal-support',
    specialization: 'Family Therapy',
    experience: '10 years',
    rating: 5,
    reviews: 145,
    price: 65,
    priceUnit: '/session',
    location: 'Amsterdam',
    verified: true,
    topRated: true,
    available: 'This week',
  },
  {
    id: 10,
    name: 'Pieter Smit',
    avatar: 'PS',
    title: 'Friendly companion for elderly - walks, conversations, activities',
    category: 'personal-support',
    specialization: 'Companionship',
    experience: '4 years',
    rating: 4,
    reviews: 92,
    price: 20,
    priceUnit: '/hr',
    location: 'Eindhoven',
    verified: true,
    topRated: false,
    available: 'Weekends',
  },
];

// Provider detail data
export const providerDetails = {
  1: {
    id: 1,
    name: 'Priya Sharma',
    avatar: 'PS',
    title: 'Certified Nurse | Post-Surgery & Recovery Specialist',
    bio: "With over 8 years of experience in post-operative care, I specialize in helping patients recover comfortably at home. My approach combines clinical expertise with genuine compassion — because healing happens best when you feel truly cared for. I've worked with major hospitals in Mumbai and now focus exclusively on private home care.",
    location: 'Mumbai, India',
    experience: '8 years',
    rating: 4.9,
    reviews: 312,
    repeatHire: 94,
    responseTime: '< 1 hour',
    languages: ['English', 'Hindi', 'Marathi'],
    verified: true,
    topRated: true,
    category: 'healthcare',
    packages: {
      basic: {
        name: 'Basic Care',
        price: 28,
        hours: '4 hours',
        features: ['Vital monitoring', 'Medication administration', 'Basic wound care', 'Patient mobility assistance'],
      },
      standard: {
        name: 'Standard Care',
        price: 55,
        hours: '8 hours',
        features: [
          'All Basic features',
          'Detailed health reports',
          'Meal preparation assistance',
          'Family communication updates',
          'Light physiotherapy',
        ],
      },
      premium: {
        name: 'Premium Care',
        price: 95,
        hours: '12 hours',
        features: [
          'All Standard features',
          '24/7 availability on call',
          'Coordination with doctors',
          'Emergency response ready',
          'Comprehensive recovery plan',
        ],
      },
    },
    included: [
      'Initial health assessment',
      'Personalized care plan',
      'Daily progress reports',
      'Medication management',
      'Vital signs monitoring',
      'Wound dressing & care',
      'Patient mobility support',
      'Family guidance & training',
    ],
    credentials: [
      { name: 'B.Sc Nursing', institution: 'Mumbai University', year: '2015' },
      { name: 'Post-Surgery Care Certification', institution: 'Apollo Hospitals', year: '2018' },
      { name: 'BLS & ACLS Certified', institution: 'American Heart Association', year: '2023' },
    ],
    reviewsList: [
      {
        id: 1,
        author: 'Vikram M.',
        rating: 5,
        date: '2 weeks ago',
        text: "Priya took care of my mother after her hip replacement surgery. Her professionalism and warmth made a difficult time so much easier. Highly recommend!",
      },
      {
        id: 2,
        author: 'Emma V.',
        rating: 5,
        date: '1 month ago',
        text: 'Exceptional care! Priya went above and beyond, even helping us understand the medications and recovery process. My father recovered faster than expected.',
      },
      {
        id: 3,
        author: 'Jan B.',
        rating: 5,
        date: '2 months ago',
        text: 'Very knowledgeable and caring. She treated my grandmother like family. The daily updates gave us peace of mind while we were at work.',
      },
    ],
  },
};

// Generate provider details for all providers
for (let i = 2; i <= 10; i++) {
  const provider = allProviders.find((p) => p.id === i);
  if (provider) {
    providerDetails[i] = {
      ...providerDetails[1],
      id: i,
      name: provider.name,
      avatar: provider.avatar,
      title: `${provider.specialization} Specialist`,
      location: provider.location,
      experience: provider.experience,
      rating: provider.rating === 5 ? 4.9 : 4.5,
      reviews: provider.reviews,
      packages: {
        basic: { ...providerDetails[1].packages.basic, price: provider.price },
        standard: { ...providerDetails[1].packages.standard, price: Math.round(provider.price * 2) },
        premium: { ...providerDetails[1].packages.premium, price: Math.round(provider.price * 3.5) },
      },
    };
  }
}

// Provider profile data
export const profileData = {
  1: {
    id: 1,
    name: 'Priya Sharma',
    avatar: 'PS',
    title: 'Certified Nurse | Post-Surgery & Recovery Specialist',
    tagline: 'Bringing compassionate care to your home',
    bio: 'With over 8 years of experience in post-operative care, I specialize in helping patients recover comfortably at home. My approach combines clinical expertise with genuine compassion — because healing happens best when you feel truly cared for.',
    location: 'Mumbai, India',
    memberSince: 'January 2020',
    experience: '8 years',
    rating: 4.9,
    totalReviews: 312,
    totalBookings: 456,
    responseTime: 'Within 1 hour',
    languages: ['English', 'Hindi', 'Marathi'],
    verified: true,
    topRated: true,
    areasServed: ['Mumbai', 'Thane', 'Navi Mumbai'],
    workingStyle:
      'I believe in building a relationship with my patients and their families. My care approach includes regular health updates, family education on patient care, and 24/7 availability for emergencies.',
    services: [
      {
        id: 1,
        title: 'Post-Surgery Recovery Care',
        description: 'Complete nursing care for patients recovering from surgery',
        price: 28,
        unit: '/hr',
        rating: 4.9,
        reviews: 156,
      },
      {
        id: 2,
        title: 'Elderly Daily Care',
        description: 'Compassionate daily assistance for senior family members',
        price: 25,
        unit: '/hr',
        rating: 4.8,
        reviews: 98,
      },
      {
        id: 3,
        title: 'Wound Care & Dressing',
        description: 'Professional wound management and dressing changes',
        price: 18,
        unit: '/visit',
        rating: 5.0,
        reviews: 58,
      },
    ],
    credentials: [
      { name: 'B.Sc Nursing', institution: 'Mumbai University', year: '2015', verified: true },
      { name: 'Post-Surgery Care Certification', institution: 'Apollo Hospitals', year: '2018', verified: true },
      { name: 'BLS & ACLS Certified', institution: 'American Heart Association', year: '2023', verified: true },
      { name: 'Geriatric Care Specialist', institution: 'Indian Nursing Council', year: '2021', verified: true },
    ],
    reviews: [
      {
        id: 1,
        author: 'Vikram Mehta',
        avatar: 'VM',
        rating: 5,
        date: '2 weeks ago',
        service: 'Post-Surgery Recovery Care',
        text: "Priya took care of my mother after her hip replacement surgery. Her professionalism and warmth made a difficult time so much easier. She was always punctual and kept us informed about everything.",
      },
      {
        id: 2,
        author: 'Emma van Dijk',
        avatar: 'EV',
        rating: 5,
        date: '1 month ago',
        service: 'Elderly Daily Care',
        text: "Exceptional care for my father! Priya treated him with such dignity and patience. She even taught us how to help with his exercises when she wasn't there.",
      },
      {
        id: 3,
        author: 'Jan Bakker',
        avatar: 'JB',
        rating: 5,
        date: '2 months ago',
        service: 'Post-Surgery Recovery Care',
        text: 'Very knowledgeable and caring. The daily updates gave us peace of mind while we were at work. Highly recommend!',
      },
    ],
  },
};

// Generate profile data for all providers
for (let i = 2; i <= 10; i++) {
  const provider = allProviders.find((p) => p.id === i);
  if (provider) {
    profileData[i] = {
      ...profileData[1],
      id: i,
      name: provider.name,
      avatar: provider.avatar,
      title: `${provider.specialization} Specialist`,
      location: provider.location,
      experience: provider.experience,
      rating: provider.rating === 5 ? 4.9 : 4.5,
      totalReviews: provider.reviews,
      totalBookings: Math.round(provider.reviews * 1.5),
      services: profileData[1].services.map((s) => ({ ...s, price: provider.price })),
    };
  }
}
